import React, { createContext } from 'react';
import { notification } from 'antd';
const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
    const duration = 5;
    const placement = 'topRight';

    notification.config({
        maxCount: 4,
        duration,
        placement,
    });

    const notifyError = ({ key, message, description }) => {
        if (!key) {
            key = Date.now();
        }
        notification.error({
            key,
            message,
            description,
        });
        return key;
    };

    const notifySuccess = ({ key, message, description }) => {
        if (!key) {
            key = Date.now();
        }
        notification.success({
            key,
            message,
            description,
        });
        return key;
    };

    const notifyWarning = ({ key, message, description }) => {
        if (!key) {
            key = Date.now();
        }
        notification.warning({
            key,
            message,
            description,
        });
        return key;
    };

    const notifyInfo = ({ key, message, description }) => {
        if (!key) {
            key = Date.now();
        }
        notification.info({
            key,
            message,
            description,
            duration,
            placement,
        });
        return key;
    };

    const notify = ({
        key,
        type = 'info',
        message = 'Notification Title',
        description = 'This is the content of the notification. This is the content of the notification. This is the content of the notification.',
        icon = undefined,
        placement = 'topRight',
        duration = 3,
        btn,
    }) => {
        if (!key) {
            key = Date.now();
        }
        notification[type]({
            key,
            message,
            description,
            icon,
            placement,
            duration,
            btn,
        });
        return key;
    };
    return (
        <NotificationContext.Provider
            value={{
                notify,
                notifyInfo,
                notifyError,
                notifySuccess,
                notifyWarning,
            }}
        >
            {children}
        </NotificationContext.Provider>
    );
};

export const useNotification = () => {
    const context = React.useContext(NotificationContext);
    if (!context) {
        throw new Error('useNotification must be used within a UserProvider');
    }
    return context;
};
